export const styles = {
  carsCard: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: "24px",
    width: "100%",
    maxWidth: "1280px",
    margin: "40px auto",
    padding: "0 16px",
    borderRadius: "8px",
    alignItems: "stretch",
  },
  container: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    background: "transparent",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
  },
  card: {
    background: "white",
    borderRadius: "5px",
    overflow: "hidden",
    maxWidth: "500px",
    width: "100%",
    boxShadow: "0 3px 8px rgba(0, 0, 0, 0.3)",
    transition: "transform 0.3s ease",
  },
  imageContainer: {
    position: "relative",
    width: "100%",
    height: "250px",
    overflow: "hidden",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  badge: {
    position: "absolute",
    top: "15px",
    right: "15px",
    background: "rgba(255, 255, 255, 0.95)",
    padding: "8px 16px",
    borderRadius: "25px",
    fontWeight: "600",
    fontSize: "14px",
    color: "#333",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
  },
  content: {
    padding: "0px 10px",
  },
  header: {
    marginBottom: "20px",
  },
  title: {
    fontSize: "28px",
    fontWeight: "700",
    color: "#1a1a1a",
    marginBottom: "5px",
    margin: "0 0 5px 0",
    textAlign: "start",
  },
  year: {
    fontSize: "16px",
    color: "#666",
    fontWeight: "500",
    margin: 0,
    textAlign: "start",
  },
  price: {
    fontSize: "32px",
    fontWeight: "800",
    color: "#0048e0",
    marginBottom: "20px",
  },
  currency: {
    fontSize: "20px",
  },
  specsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))",
    gap: "15px",
    marginBottom: "25px",
  },
  specItem: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "12px",
    background: "#f8f9fa",
    borderRadius: "10px",
    transition: "background 0.3s ease",
  },
  icon: {
    fontSize: "20px",
  },
  specDetails: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: "11px",
    color: "#666",
    textTransform: "uppercase",
    fontWeight: "600",
    letterSpacing: "0.5px",
  },
  value: {
    fontSize: "14px",
    color: "#1a1a1a",
    fontWeight: "600",
  },
  button: {
    width: "100%",
    padding: "16px",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    border: "none",
    borderRadius: "12px",
    fontSize: "16px",
    fontWeight: "700",
    cursor: "pointer",
    transition: "all 0.3s ease",
    textTransform: "uppercase",
    letterSpacing: "1px",
  },
};
